export default __webpack_public_path__ + "static/heroimg-df0447869906ba4be6020c81bfecfd55.png";